import { BRAND_COMPONENTS } from './brandComponents';
import { CORE_COMPONENTS } from './coreComponents';
import { EXTRA_COMPONENTS } from './extraComponents';
import { MEDIA_COMPONENTS } from './mediaComponents';

export * from './shared';

/**
 * Wszystkie gotowe elementy kreacji. Podział na pliki wynika z limitu długości
 * pliku w tym repo; kolejność na liście jest tą, którą widzi użytkownik.
 */
export const AD_COMPONENTS = [
  ...BRAND_COMPONENTS,
  ...CORE_COMPONENTS,
  ...EXTRA_COMPONENTS,
  ...MEDIA_COMPONENTS,
];
